import { render, staticRenderFns } from "./AnnouncementModal.vue?vue&type=template&id=4173b518&scoped=true"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4173b518",
  null
  
)

export default component.exports